<template>
  <div>
    <!-- {{ JSON.stringify(dataSource) }} -->
    <dx-data-grid
      :show-borders="true"
      :ref="'batch-child-grid-' + templateData.key"
      :columns="masterDetailColumns"
      :data-source="dataSource"
      @editor-preparing="onEditorPreparing"
      @content-ready="onContentReady"
      @init-new-row="onInitNewRow"
      @row-removed="onRowRemoved"
      :columnChooser="{
        enabled: false,
      }"
    >
      <DxSearchPanel :visible="false" />
      <DxEditing
        :allow-deleting="allowEdit"
        :allow-updating="allowEdit"
        mode="cell"
      />
      <template #itemSelect="{ data }">
        <div class="custom-auto-complete">
          <span class="auto-complete-primary">{{ data.BatchNo }}</span>
          <span class="auto-complete-secondary">{{ data.SupplierCode }}</span>
          <span class="auto-complete-secondary">{{ data.SupplierName }}</span>
          <span class="auto-complete-secondary">{{ data.UseByDate }}</span>
          <span class="auto-complete-secondary">{{ data.AvailableQty }}</span>
        </div>
      </template>
      <template #supplier-cell-template="{ data }">
        <GcDescriptionCodeCellTemplate
          :description="data.data.SupplierName"
          :code="data.data.SupplierCode"
        />
      </template>
      <template #expiry-date-template="{ data }">
        <DxDateBox :value="data.data.ExpiryDate" type="date" />
      </template>

      <template #available-quantity-template="{ data }">
        <DxNumberBox :value="data.data.AvailableQty" />
      </template>

      <template #quantity-template="{ data }">
        <DxNumberBox :value="data.data.Qty" />
      </template>

      <template #qtyEditTemplate="{ data }">
        <div>
          <div>
            <DxNumberBox
              :value="data.value"
              @value-changed="batchQtyChanged($event, data)"
              :format="data.column.format"
              class="gc-grid-number-box-editor"
              :min="0"
              :max="999999999.99"
              :disabled="data.data.BatchNo == '' || !allowEdit"
            />
          </div>
        </div>
      </template>
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";
import { DxNumberBox } from "devextreme-vue/number-box";
import BaseViewMixin from "../../src/v1/_mixins/base.view";
import { alert } from "devextreme/ui/dialog";

import { ProductBatchService } from "../_services/api/inventory/product-batch.service";

let baseLineBase = {
  BatchNo: "",
  SupplierName: "",
  SupplierCode: "",
  UseByDate: "",
  AvailableQty: null,
  TransferQty: 0,
};

let addingNewBatchRow = false;

export default {
  components: { DxDataGrid, DxDateBox, DxNumberBox },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    updateReviewList: {
      type: Function,
    },
    brokenGridValidations: {
      type: Array,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSource: this.templateData.data.StockTransferProductBatches,
    };
  },
  created() {
    if (this.allowEdit && this.dataSource.length == 0) this.onAddClickHandler();
  },
  methods: {
    onEditorPreparing(e) {
      var that = this,
        rowIndex = e.row && e.row.rowIndex;
      if (e.dataField === "BatchNo") {
        e.editorOptions.onValueChanged = function (e) {
          ProductBatchService.getByBatchNo(
            e.value,
            that.templateData.data.ItemCode,
            that.parentModel.BranchCode
          ).then((res) => {
            if (res.data.value.length > 0) {
              let rec = res.data.value[0];
              that.dataSource[rowIndex].BatchNo = rec.BatchNo;
              that.dataSource[rowIndex].SupplierCode = rec.SupplierCode;
              that.dataSource[rowIndex].SupplierName = rec.SupplierName;
              that.dataSource[rowIndex].UseByDate = rec.UseByDate;
              that.dataSource[rowIndex].AvailableQty = rec.AvailableQty;
              that.dataSource[rowIndex].ItemCode = rec.ItemCode;
              that.dataSource[rowIndex].BranchCode = rec.BranchCode;
            } else {
              that.dataSource[rowIndex].BatchNo = "";
              that.dataSource[rowIndex].SupplierCode = "";
              that.dataSource[rowIndex].SupplierName = "";
              that.dataSource[rowIndex].UseByDate = null;
              that.dataSource[rowIndex].AvailableQty = null;
              that.dataSource[rowIndex].ItemCode = "";
              that.dataSource[rowIndex].BranchCode = "";
            }
          });
        };
      }
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    batchQtyChanged(e, cellInfo) {
      if (e.value > cellInfo.data.AvailableQty) {
        let errorMsg = {
          Code: this.templateData.data.Code,
          Description: this.templateData.data.Description1,
          Batch: cellInfo.data.BatchNo,
          TransferQty: e.value,
          AvailableQty: cellInfo.data.AvailableQty,
        };
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === this.templateData.data.Code &&
            x.Batch === cellInfo.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations[index] = errorMsg;
        } else {
          this.brokenGridValidations.push(errorMsg);
        }
        this.$nextTick(function () {
          alert(
            `Batch ${cellInfo.data.BatchNo} of item : ${
              this.templateData.data.ItemDescription
            } has a transfer quantity of ${this.formatNumber(
              e.value
            )} which is more than the available quantity of ${this.formatNumber(
              cellInfo.data.AvailableQty
            )}`,
            "Validation Errors"
          );
        });
      } else {
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === this.templateData.data.Code &&
            x.Batch === cellInfo.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations.splice(index, 1);
        }
      }
      if (this.dataSource.length > 0) {
        this.dataSource[cellInfo.rowIndex].TransferQty = e.value;
        this.recalculateTotal();
        this.updateReviewList(this.templateData.data);
      }
    },
    onInitNewRow(e) {
      e.data.TransferQty = 0;
    },
    onRowRemoved(e) {
      this.templateData.data.TransferQty -= e.data.TransferQty;
    },

    // eslint-disable-next-line no-unused-vars
    onContentReady(e) {
      // this.$logger.debug("content ready", e);

      if (addingNewBatchRow) {
        addingNewBatchRow = false;
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        let recordCount = grid.getDataSource().items().length;
        // this.$logger.debug(recordCount);
        if (recordCount > 0) {
          let editElement = grid.getCellElement(recordCount - 1, 0);
          grid.focus(editElement);
          editElement.click();
        }
      }
    },

    onAddClickHandler() {
      let obj = Object.assign({}, baseLineBase);
      this.dataSource.push(obj);
      if (this.$refs["batch-child-grid-" + this.templateData.key]) {
        let grid = this.$refs["batch-child-grid-" + this.templateData.key]
          .instance;

        grid.repaint();
      }
      addingNewBatchRow = true;
    },

    recalculateTotal() {
      this.$logger.debug(
        "recalculateTotal StockTransferProductBatches",
        this.templateData.data.StockTransferProductBatches
      );

      // eslint-disable-next-line no-unused-vars
      let totalBatchTransferQty = 0;
      this.dataSource.forEach((x) => {
        totalBatchTransferQty += x.TransferQty;
      });

      this.templateData.data.TransferQty = totalBatchTransferQty;
      this.templateData.data.StockTransferProductBatches = this.dataSource;
    },
  },
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },

    masterDetailColumns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Batch",
          dataField: "BatchNo",
          gcType: "String",
          gcSubType: "PrimaryChildRecord",
          editorType: "dxSelectBox",
          width: 250,
          editorOptions: {
            dataSource: ProductBatchService.dataSourceConfig(
              "api/ConsumeProductBatch",
              {
                filter: [
                  ["ItemCode", "=", this.templateData.data.ItemCode],
                  ["BranchCode", "=", this.parentModel.BranchCode],
                  ["SourceTransactionType", "=", ""],
                  ["SourceTransactionNo", "=", 0],
                  ["SourceTransactionLine", "=", 0],
                  ["SourceTransactionProcessCode", "=", ""],
                ],
              }
            ),
            displayExpr: "BatchNo",
            valueExpr: "BatchNo",
            searchExpr: ["BatchNo"],
            searchMode: "contains",
            showClearButton: true,
            itemTemplate: "itemSelect",
            searchEnabled: true,
            dropDownOptions: {
              minWidth: 500,
            },
            readOnly: this.allowEdit == false,
          },
          showEditorAlways: true,
          allowEditing: true,
          cssClass: "gc-editor-cell",
        },

        {
          gcLabel: "Supplier",
          dataField: "SupplierName",
          cellTemplate: "supplier-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
        },

        {
          gcLabel: "Use By Date",
          dataField: "UseByDate",
          gcType: "Date",
        },

        {
          gcLabel: "Available",
          dataField: "AvailableQty",
          gcType: "Decimal-6-2",
        },

        {
          gcLabel: "Quantity",
          dataField: "TransferQty",
          gcType: "Decimal-6-2",
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: this.allowEdit,
        },

        {
          gcLabel: "",
          gcType: "String",
          type: "buttons",
          width: 110,
          visible: this.allowEdit,
          buttons: [
            "delete",
            {
              hint: "Add Batch Line",
              icon: "plus",
              visible: true,
              onClick: this.onAddClickHandler.bind(this),
            },
          ],
        },
      ]);
    },
  },
  watch: {
    noOfRecords: {
      handler: function (value) {
        // add a record if the no of items in the datasource is 0
        if (this.allowEdit && value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
/* @import "../dx-styles.scss"; */
</style>
